import angular from 'angular';

angular
  .module('container')

  .factory('Containers', [
    '$resource',
    'Upload',
    '$translate',
    '$log',
    'CONF',
    'API_CONFIG',
    function($resource, Upload, $translate, $log, CONF, API_CONFIG) {
      var Containers = $resource(
        API_CONFIG.url + '/v1/container/:containerId',
        { containerId: '@id' },
        {
          update: { method: 'PUT' },
          getNew: { url: API_CONFIG.url + '/v1/container/new' }
        }
      );

      Containers.uploadMappingFile = function(file, containerId) {
        var upload = Upload.upload({
          method: 'POST',
          url: API_CONFIG.url + '/v1/container/' + containerId + '/mapping',
          file: file
        }).progress(function(evt) {
          var progressPercentage = parseInt((100.0 * evt.loaded) / evt.total);
          $log.debug('progress: ' + progressPercentage + '% ' + evt.config.file.name);
        });
        return upload;
      };

      Containers.updateContainers = function(criteria, mappingFile) {
        var upload = Upload.upload({
          url: API_CONFIG.url + '/v1/container/update',
          data: {
            file: mappingFile ? mappingFile.filedata : null,
            mappingMode: criteria.mappingMode,
            containersIds: criteria.containersSelected,
            platformPath: criteria.platformPath,
            createRemoteFolders: criteria.createRemoteFolders
          }
        });
        return upload;
      };

      Containers.getMappingFile = function(containerId) {
        return API_CONFIG.url + '/v1/container/' + containerId + '/mapping';
      };

      // Ajout de la propriété fullname du principal, util pour le filtre de la societé
      Object.defineProperty(Containers.prototype, 'principalFullname', {
        get: function() {
          return this.principalId + ', ' + this.principalName;
        },
        set: function(principalFullname) {
          var res = principalFullname.split(', ');
          this.principalId = res[0];
          this.principalName = res[1];
        }
      });

      return Containers;
    }
  ]);
